import { render } from "./CalibracaoModal.vue?vue&type=template&id=0704c167&scoped=true"
import script from "./CalibracaoModal.vue?vue&type=script&lang=js"
export * from "./CalibracaoModal.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./CalibracaoModal.vue?vue&type=style&index=1&id=0704c167&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0704c167"]])

export default __exports__